import { render, staticRenderFns } from "./PropostasAgrupadas.vue?vue&type=template&id=37fd10d6"
import script from "./PropostasAgrupadas.vue?vue&type=script&lang=js"
export * from "./PropostasAgrupadas.vue?vue&type=script&lang=js"
import style0 from "./PropostasAgrupadas.vue?vue&type=style&index=0&id=37fd10d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports